var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel d-flex align-items-md-center"},[_c('b-form-checkbox',{attrs:{"size":"lg","value":_vm.checkedvalue,"unchecked-value":_vm.uncheckedvalue},on:{"change":_vm.onDataChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }